export { default } from './src/onlineCall';

module.exports.mangoCall = require('./src/mangoCall');
module.exports.zingayaCall = require('./src/zingayaCall');
